import React from 'react';
import { Avatar } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import WorkspacePremium from '@mui/icons-material/WorkspacePremium';
import Person from '@mui/icons-material/Person';
import LocationChip from '../components/LocationChip';
import Horse from '../components/Horse';
import BarnIcon from '../components/CustomIcons/Barn';

export const getLocationForTags = (tags, locationTagTypeId, locationsMap) => {
  const locationTag = tags.find((t) => t.tagType.id === locationTagTypeId);
  const id = (locationTag && locationTag.id) || -1;
  return (id && locationsMap && locationsMap[id] && locationsMap[id][0]) || null;
};

export const getBarnHorseForTags = (tags, horseTagTypeId, barnHorsesMap) => {
  const horseTag = tags.find((t) => t.tagType.id === horseTagTypeId);
  const id = (horseTag && horseTag.id) || -1;
  return (id && barnHorsesMap && barnHorsesMap[id] && barnHorsesMap[id][0]) || null;
};

export const getBarnHorsesForTags = (tags, horseTagTypeId, barnHorsesMap) => tags
  .filter((t) => t.tagType.id === horseTagTypeId).map((t) => barnHorsesMap && barnHorsesMap[t.id] && barnHorsesMap[t.id][0]);

export const getChipForTags = (tags, barnHorsesMap, locationsMap, props = {}) => {
  for (let i = 0; i < tags.length; i += 1) {
    // loop over tags until we find the entity (location or barn horse)
    if (barnHorsesMap[tags[i].id]) {
      return <Horse chip size={18} horse={barnHorsesMap[tags[i].id][0].horse} {...props} key={`chip-tag-${tags[i].id}`} />;
    }
    if (locationsMap[tags[i].id]) {
      return <LocationChip location={locationsMap[tags[i].id][0]} {...props} key={`chip-tag-${tags[i].id}`} />;
    }
  }
  return 'Unknown';
};

const getIcon = (location) => {
  if (location.type === 'Competition') {
    return <WorkspacePremium sx={{ color: 'fff' }} />
  } if (location.type === 'Trainer') {
    return <Person sx={{ color: '#ffffff' }} />
  }
  return <BarnIcon color="#ffffff" fontSize={20} margin="4" />
}

export const getAvatarForTags = (tags, barnHorsesMap, locationsMap) => {
  for (let i = 0; i < tags.length; i += 1) {
    // loop over tags until we find the entity (location or barn horse)
    if (barnHorsesMap[tags[i].id]) {
      const { horse } = barnHorsesMap[tags[i].id][0];
      return (
        <Avatar
          alt={horse.name}
          src={`https://${horse.picture
            ? `${horse.picture}?cacheBust=${new Date()}`
            : `i0.wp.com/cdn.auth0.com/avatars/${horse.name.charAt(0).toLowerCase()}.png`}`}
        />
      )
    }
    if (locationsMap[tags[i].id]) {
      const location = locationsMap[tags[i].id][0];
      return (
        <Avatar>
          {getIcon(location)}
        </Avatar>
      );
    }
  }
  return <Avatar><FolderIcon /></Avatar>;
};

